import { Box } from '@mui/material';
import styled from 'styled-components';

export const DashboardContainer = styled(Box)`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.layout.sidebarWidth} 1fr ${({ theme }) => theme.layout.widgetWidth};
  height: 100vh;
  width: 100%;
  max-width: ${({ theme }) => theme.layout.dashboardMaxWidth};
  margin: 0 auto;
  overflow: hidden;
  transition: grid-template-columns ${({ theme }) => theme.duration.normal} ${({ theme }) => theme.easing.easeOut};

  /* Tablet: collapsed icon rail + full content, no widgets */
  @media (min-width: 768px) and (max-width: 1199px) {
    grid-template-columns: ${({ theme }) => theme.layout.sidebarCollapsedWidth} 1fr;
  }

  /* Mobile: single column, no sidebar */
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    padding-bottom: ${({ theme }) => theme.layout.bottomNavHeight};
  }
`;

export const SideContent = styled.aside`
  padding: ${({ theme }) => theme.spacing[4]};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100vh;
  border-left: 1px solid ${({ theme }) => theme.colors.border};

  @media (max-width: 1199px) {
    display: none;
  }
`;

